import { decodeToken } from './tokenUtils';

/**
 * Coerce API/JWT permission field to a finite number (bitmask).
 * @param {unknown} raw
 * @returns {number|undefined}
 */
function coercePermissionMask(raw) {
    if (raw === undefined || raw === null) return undefined;
    if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
    if (typeof raw === 'string' && raw !== '') {
        const n = Number(raw);
        if (Number.isFinite(n)) return n;
    }
    return undefined;
}

/**
 * Merges signed access JWT claims into the account shape used in Redux.
 * Uses JWT `permissions` when decode succeeds; otherwise `explicitPermissions` from login/refresh JSON.
 *
 * @param {object} account - Account from GET /auth/me
 * @param {string|null|undefined} accessToken
 * @param {unknown} [explicitPermissions] - e.g. `tokens.access.permissions` from login/refresh response
 * @returns {object}
 */
export function mergeAccessTokenClaims(account, accessToken, explicitPermissions) {
    if (!account) return account;
    const next = { ...account };

    let mask = undefined;

    if (accessToken) {
        const claims = decodeToken(accessToken);
        if (claims) {
            const fromJwt = coercePermissionMask(claims.permissions);
            if (fromJwt !== undefined) {
                mask = fromJwt;
            }
            if (Array.isArray(claims.roles)) {
                next.tokenRoles = claims.roles.filter((r) => typeof r === 'string');
            }
        }
    }

    if (mask === undefined) {
        mask = coercePermissionMask(explicitPermissions);
    }

    if (mask !== undefined) {
        next.permissions = mask;
    }

    return next;
}
